import * as React from 'react'
import { getHelperLinks, getLangCode } from '../../helpers'
import { HELPER_LINKS_URIS } from '../../constants'
import { ILinks, ILinksItem } from '../../interface'
import { Trans, useTranslation } from 'react-i18next'

const T_ROOT = 'pages.view404'
const T_ROOT_ACTIONS = `${T_ROOT}.actions`

const Links = ({ translationsType }: ILinks): JSX.Element => {
  const { i18n, t } = useTranslation()
  const specificLangCode = getLangCode(i18n.language)
  const T_ROOT_TYPE = `${T_ROOT}.${translationsType}`
  const LINKS = getHelperLinks(specificLangCode, t, T_ROOT_ACTIONS)

  return (
    <div data-testid='links' className='View404__Links'>
      <p className='View404__Links--title'>
        <Trans i18nKey={`${T_ROOT_TYPE}.linksDescription`}>
          <a href={`${HELPER_LINKS_URIS.helpCenter}${specificLangCode}`} rel='noreferrer' target='_blank'>
            {t(`${T_ROOT_ACTIONS}.here`)}
          </a>
        </Trans>
      </p>
      <ul className='View404__Links--ul'>
        <li>{t(`${T_ROOT_TYPE}.linksTitle`)}</li>
        {LINKS.map(({ link, target, text }: ILinksItem, index: number) => (
          <li key={index}>
            <a href={link} target={target}>
              {t(text)}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Links
